(() => {
  const clean = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const limit = (value, max = 155) => {
    const text = clean(value);
    if (text.length <= max) return text;
    return `${text.slice(0, max - 1).replace(/\s+\S*$/, '')}…`;
  };

  const productTitleFor = (img) => {
    const scope = img.closest(
      '.product, .product__info-container, .product-media-container, .product__media, .card-wrapper, .product-card-wrapper, .card, [data-product-id]'
    );
    const title = scope?.querySelector(
      '.product__title, .card__heading, .card-information__text, [class*="product-title"], h1, h2, h3'
    );
    return clean(title?.textContent) || clean(document.querySelector('main h1')?.textContent);
  };

  const collectionTitleFor = (img) => {
    const scope = img.closest('.collection-list__item, .card-wrapper, .card, [class*="collection-card"]');
    const title = scope?.querySelector('.card__heading, [class*="collection-title"], h2, h3');
    return clean(title?.textContent);
  };

  const inferAlt = (img) => {
    const src = clean(img.currentSrc || img.src).toLowerCase();
    if (src.includes('b2b-icon-1')) return 'Dropshipping-Service';
    if (src.includes('b2b-icon-2')) return 'Attraktive Händlerkonditionen';
    if (src.includes('b2b-icon-3')) return 'Schnelle und diskrete Lieferung';

    const productTitle = productTitleFor(img);
    if (productTitle) {
      const siblings = [...(img.closest('.product__media-list, .product-media-gallery, .slider, .grid')?.querySelectorAll('img') || [])];
      const index = siblings.indexOf(img);
      return index > 0 ? `${productTitle} – Ansicht ${index + 1}` : productTitle;
    }

    const collectionTitle = collectionTitleFor(img);
    if (collectionTitle) return collectionTitle;

    const linkedLabel = clean(img.closest('a')?.getAttribute('aria-label') || img.closest('a')?.getAttribute('title'));
    if (linkedLabel) return linkedLabel;

    const section = img.closest('section, .shopify-section, footer, header');
    const heading = clean(section?.querySelector('h1, h2, h3')?.textContent);
    if (heading && !src.includes('icon')) return heading;

    return '';
  };

  const repairImage = (img) => {
    if (!(img instanceof HTMLImageElement) || clean(img.getAttribute('alt'))) return;
    const alt = inferAlt(img);
    if (alt) img.setAttribute('alt', limit(alt, 125));
  };

  const ensureMetaDescription = () => {
    let meta = document.querySelector('meta[name="description"]');
    if (clean(meta?.content)) return;

    const title = clean(document.querySelector('main h1')?.textContent || document.title.split('–')[0]);
    const source = clean(
      document.querySelector('.product__description, .collection-hero__description, main .rte, main p')?.textContent
    );
    const description = source || (title ? `${title} bei Grow Master entdecken. Produktdetails, Auswahl und weitere Informationen jetzt online ansehen.` : 'Grow Equipment, Growboxen, Beleuchtung, Lüftung und Zubehör bei Grow Master entdecken.');

    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = limit(description);
  };

  const apply = (root = document) => {
    root.querySelectorAll?.('img:not([alt]), img[alt=""]').forEach(repairImage);
    ensureMetaDescription();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => apply(), { once: true });
  } else {
    apply();
  }

  new MutationObserver((records) => {
    records.forEach(({ addedNodes }) => {
      addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches('img')) repairImage(node);
        apply(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
